import React from 'react';

import type { StatusPillStatus } from '../StatusPill';
import { StatusPill } from '../StatusPill';
import type { StatusLabel } from './types';
import { getBestLabelAsset2 } from './util/getBestLableAsset2';
import { getReviewLabelAsset2 } from './util/getReviewLabelAsset2';
import { getTranscodeLabelAsset2 } from './util/getTranscodeLabelAsset2';

export type Props = {
  className?: string;
  reviewStatus?: string | null;
  transcodeStatus?: string | null;
  additionalInfo?: React.JSX.Element | null;
};

/**
 * Renders a pill component with the appropriate styling and messaging according
 * to the Ingest, Transcode, and Review status values for an asset.
 */
export const AssetStatusPill: React.FC<Props> = ({ className, transcodeStatus, reviewStatus, additionalInfo }) => {
  let display: StatusLabel;

  const transcode = getTranscodeLabelAsset2(transcodeStatus);
  const review = getReviewLabelAsset2(reviewStatus);

  display = getBestLabelAsset2(transcode, review);

  // When no labels are available, we won't show a pill
  if (!display) return null;

  return (
    <StatusPill data-testid="status-pill" status={display.type as StatusPillStatus} className={className}>
      <span className="label">{`${display.stage}: ${display.label}`}</span>
      {additionalInfo}
    </StatusPill>
  );
};
